import { any, func, bool, object, arrayOf, shape, string } from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReadingStatus from "../ReadingListDownload/reading_status";
import style from "../ReadingListDownload/styles.module.scss";
import Spinner from "../../common/Spinner";
import { Button } from "../../common";
import ReadingList from "../ReadingList/index";
import { markDocumentReadPecan } from "../../redux/actions";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";
import { submitPecanForms } from "../../redux/actions/pecanActions";
import { getPecanPDF } from "../../api/profileApi";
import ProfileImageUpload from "../../containers/ProfileImage";

const PecanOnboarding = ({
  appData,
  pecanReadingListLoading,
  readingList,
  markDocumentReadFunc,
  submitPecanFormsFunc,
}) => {
  const { pecanOnboarding } = { ...{ pecanOnboarding: {} }, ...appData };
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

  const submittedInduction =
    pecanOnboarding &&
    pecanOnboarding.forms &&
    pecanOnboarding.forms.submittedInduction;

  const submittedAssessment =
    pecanOnboarding &&
    pecanOnboarding.forms &&
    pecanOnboarding.forms.submittedAssessment;

  const readDocuments =
    (pecanOnboarding && pecanOnboarding.readDocuments) || [];

  const readingListWithStatus = readingList.map((download) => ({
    ...download,
    status: readDocuments.includes(filenameFromUrl(download.link))
      ? ReadingStatus.Done
      : ReadingStatus.Todo,
  }));

  const FormsWithStatus = [
    {
      status:
        pecanOnboarding &&
        pecanOnboarding.forms &&
        pecanOnboarding.forms.nextOfKinForm
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Employee & Next of Kin Details",
      link: "nextOfKinForm",
    },
    {
      status:
        pecanOnboarding &&
        pecanOnboarding.forms &&
        pecanOnboarding.forms.healthForm
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Employee Health Questionnaire",
      link: "healthQuestionnaireForm",
    },
  ];

  const canSubmitPart1 = readingListWithStatus.every(
    (doc) => doc.status === ReadingStatus.Done
  );
  const canSubmitPart2 = FormsWithStatus.every(
    (doc) => doc.status === ReadingStatus.Done
  );

  const handleSubmit = () => {
    submitPecanFormsFunc(appData.pecanOnboarding.forms);
  };

  const triggerDownload = () => {
    getPecanPDF().then((response) => {
      const link = document.createElement("a");
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `Pecan_Induction.pdf`;
      link.click();
    });
  };

  const determineStatus = (status) => {
    if (submittedInduction) {
      return 3;
    }
    if (status === 2) {
      return 4;
    }
    return status;
  };

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">Pecan Deluxe Candy Induction</h2>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6">
          <div
            className={`${style.readingList__wrapper} section-body pt-1 bg-white`}
          >
            <ReadingList
              title="Induction"
              description="Please download and complete all of the below forms. Once you have completed all forms, please click on the Submit button to finish your onboarding process. Once you have submitted your forms you will be unable to edit them. If you have any queries about the forms, please speak to your HRGO Consultant."
              isLoading={pecanReadingListLoading}
              readingListWithStatus={readingListWithStatus}
              currentlyReading={currentlyReading}
              setCurrentlyReading={setCurrentlyReading}
              markDocumentRead={markDocumentReadFunc}
              isPecan={true}
            />
            {FormsWithStatus.map((el) => {
              return (
                <OnboardingListItem
                  title={el.title}
                  status={determineStatus(el.status)}
                  btnText={
                    el.status === ReadingStatus.Todo ? "Complete" : "Edit"
                  }
                  key={el.title}
                  url={`/profile/edit/onboarding-pecan/${el.link}`}
                  isPecan={true}
                />
              );
            })}
            <div className={style.buttonContainer}>
              {!submittedInduction ? (
                <Fragment>
                  <div className={style.submitButtonDesktop}>
                    Please click on the Submit button for your forms to be sent
                    to HRGO.
                  </div>
                  <Button
                    classes={`btn btn-primary ${style.buttonSubmit}`}
                    onClick={handleSubmit}
                    disabled={
                      canSubmitPart1 &&
                      canSubmitPart2 &&
                      !pecanReadingListLoading
                        ? ""
                        : "disabled"
                    }
                  >
                    {pecanReadingListLoading ? (
                      <Fragment>
                        Submit <Spinner />
                      </Fragment>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Fragment>
              ) : (
                <button
                  className="btn btn-primary"
                  onClick={triggerDownload}
                  disabled={pecanReadingListLoading ? "disabled" : ""}
                >
                  {pecanReadingListLoading ? (
                    <Fragment>
                      Submit <Spinner />
                    </Fragment>
                  ) : (
                    "Download Complete PDF"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className={`${style.readingList__wrapper} section-body pt-1 mb-2 bg-white`}
          >
            <h5 style={{ marginTop: "10px" }} className="px-1">
              Assessment
            </h5>
            <p className="px-1">
              Please complete the assessment below. If you have any queries
              about the assessment, please speak to your HRGO Consultant.
            </p>
            <OnboardingListItem
              disableDownload={false}
              title="Assessment Questionnaire"
              status={submittedAssessment ? 3 : 1}
              btnText={"Complete"}
              url={`/profile/edit/onboarding-pecan/assessment`}
            />
          </div>
          <div
            className={`${style.readingList__wrapper} section-body bg-white p-1 my-1 mt-lg-2 `}
          >
            <h5>Working at Pecan Deluxe Candy</h5>
            <p>
              Please click on the link below to learn more about working at
              Pecan Deluxe Candy.
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <a
                className="btn btn-primary"
                style={{ alignSelf: "flex-end", justifySelf: "flex-end" }}
                href="https://youtu.be/Ytxhl7LR5Ow"
                target="_blank"
                rel="noreferrer"
              >
                Open Video
              </a>
            </div>
          </div>
          <div
            className={`${style.readingList__wrapper} section-body bg-white p-1 my-1 mt-lg-2 `}
          >
            <h5>Profile Image</h5>
            <p>
              We need to provide Pecan Deluxe Candy an image of you for
              identification purposes. If you have uploaded a profile image on
              your HRGO Candidate Account, this is shown below and we can
              provide Pecan that image. If you wish to change it to a different
              image or have not yet uploaded an image to your HRGO Candidate
              Account, please action below.
            </p>

            {appData.profileImage &&
              (appData.profileImage.previewContent ||
                appData.profileImage.url) && (
                <div className="rounded-circle d-flex justify-content-center">
                  <img
                    style={{ maxWidth: "100%", width: "auto", height: "auto" }}
                    src={
                      appData.profileImage.previewContent
                        ? `data:image/jpg;base64,${appData.profileImage.previewContent}`
                        : appData.profileImage.url
                    }
                  />
                </div>
              )}
            <ProfileImageUpload showHeader={false} redirectAfterSave={false} />
          </div>
          <div className="w-100 d-flex justify-content-end mt-4">
            <Link to="/profile" className="btn btn-primary px-3">
              Back to My Account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

PecanOnboarding.propTypes = {
  appData: any,
  submitDnataFormFunc: func,
  pecanReadingListLoading: bool,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  pecanOnboarding: object,
  markDocumentReadFunc: func.isRequired,
  submitPecanFormsFunc: func.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  pecanReadingListLoading: state.core.pecanReading.isLoading,
  pecanOnboarding: state.core.app.pecanOnboarding,
  readingList: state.core.umbracoContent.pecanReadingList,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadPecan,
  submitPecanFormsFunc: submitPecanForms,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(PecanOnboarding);
